module.exports = __webpack_public_path__ + "static/media/308.e27686c7.svg";